'use strict'

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({
  template: require('./templates/empty-service-list.hbs'),
});
